import { Controller } from "@hotwired/stimulus"

// Neutral's side sheets open with a plain #anchor (:target), so they work without script. Under Turbo a
// same-page anchor click can set the hash without the browser updating :target, so the sheet stays hidden.
// This opens and closes them with a class as well, and keeps the hash in step.
export default class extends Controller {
    connect() {
        this.onClick = this.onClick.bind(this)
        this.onKey = this.onKey.bind(this)
        this.element.addEventListener("click", this.onClick)
        document.addEventListener("keydown", this.onKey)
        this.openFromHash()
    }

    disconnect() {
        this.element.removeEventListener("click", this.onClick)
        document.removeEventListener("keydown", this.onKey)
    }

    onClick(event) {
        const link = event.target.closest("a[href^='#']")
        if (!link) return
        const hash = link.getAttribute("href")
        if (hash.startsWith("#sheet-")) {
            const sheet = document.getElementById(hash.slice(1))
            if (!sheet) return
            event.preventDefault()
            this.closeAll()
            sheet.classList.add("is-open")
            history.replaceState(null, "", hash)
        } else if (link.classList.contains("neg-sheet-scrim") || link.classList.contains("neg-sheet-close") || link.closest(".neg-sheet")) {
            event.preventDefault()
            this.closeAll()
            history.replaceState(null, "", hash)
            document.getElementById(hash.slice(1))?.scrollIntoView({ block: "center" })
        }
    }

    onKey(event) {
        if (event.key === "Escape") this.closeAll()
    }

    openFromHash() {
        if (!location.hash.startsWith("#sheet-")) return
        document.getElementById(location.hash.slice(1))?.classList.add("is-open")
    }

    closeAll() {
        this.element.querySelectorAll(".neg-sheet.is-open").forEach((sheet) => sheet.classList.remove("is-open"))
    }
}
